import React from "react";

const ProjectCard = ({ title, subtitle, children, link, githubLink }) => {
  return (
    <div className="flex flex-col w-full bg-[#c0c0c0] border-[0.12rem] border-t-[#f5f5f5] border-l-[#f5f5f5] border-b-black border-r-black px-[0.8rem] pb-6 shadow-sm">
      {/* Header Section */}
      <div className="pt-[0.4rem] pb-[0.24rem] px-[0.05rem] flex flex-wrap items-center justify-between gap-x-4">
        <div className="flex items-center">
          {/* Title */}
          <h3 className="text-[2.9rem] lg:text-[2.4rem] xl:text-[2.9rem] font-bold">{title}</h3>

          {/* Links */}
          {link && (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-3 shrink-0"
            >
              <img
                src="/link-icon.png"
                alt="link icon"
                className="h-[1.6rem] w-[1.6rem] border-[0.12rem] border-t-[#f5f5f5] border-l-[#f5f5f5] border-b-black border-r-black"
              />
            </a>
          )}
          {githubLink && (
            <a
              href={githubLink}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-3 shrink-0"
            >
              <img
                src="/contact-logos/github-logo.png"
                alt="github icon"
                className="h-[1.6rem] w-[1.6rem] border-[0.12rem] border-t-[#f5f5f5] border-l-[#f5f5f5] border-b-black border-r-black"
              />
            </a>
          )}
        </div>

        {/* Subtitle */}
        {subtitle && (
          <p
            className="text-[1.4rem] md:text-[1.6rem] lg:text-[1.2rem] xl:text-[1.6rem] font-bold"
          >
            {subtitle}
          </p>
        )}
      </div>

      {/* Content Section */}
      <div
        className="flex-1 border-[0.16rem] text-[1.17rem] leading-[1.4rem] experience-card-checker bg-gray-100 border-t-[#7f787e] border-l-[#7f787e] border-b-white border-r-white px-3 py-2"
      >
        {children}
      </div>
    </div>
  );
};

export default ProjectCard;
